/**
 * Text insets for the built-in value cells (text, address).
 *
 * PROPERTY rows: the sibling selector Buttons are the `default` (32px) rung,
 * which puts a label 12px in (1px border + 11px padding). The rest display is
 * borderless (the wash treatment), so it pads the full 12px; the editing
 * input sits inside the cell's 1px ring, so it pads 11px — the text never
 * moves when editing starts, and every value in the column starts on one
 * line.
 *
 * TABLE cells: the cell wears a 1px border in both states (transparent at
 * rest, the ring while editing), so display and input both pad 7px and the
 * text sits 8px in either way.
 */
import { ROW_RUNGS } from "@salestrak/ui";

export const PROPERTY_VALUE_REST_INSET_CLASS = "px-3";

/** The property surface's control rung: the value cell stands at the same
 *  32px as the sibling selector Buttons, centered in the library
 *  `PropertyRow`'s 44px pitch. Table cells never set this — there the row is
 *  the table's, and the cell fills it. */
export const PROPERTY_CONTROL_HEIGHT = ROW_RUNGS.propertyRow;

export const PROPERTY_VALUE_EDIT_INSET_CLASS = "px-[calc(--spacing(3)-1px)]";

/** {@link PROPERTY_VALUE_EDIT_INSET_CLASS} on the leading edge only — for the
 *  first element of a composite editor (the phone editor's flag trigger),
 *  whose trailing inset is the gap to the next part. */
export const PROPERTY_VALUE_EDIT_LEAD_INSET_CLASS =
  "pl-[calc(--spacing(3)-1px)]";

/** {@link PROPERTY_VALUE_EDIT_INSET_CLASS} for an input nested in a
 *  composite control. */
export const PROPERTY_VALUE_INPUT_INSET_CLASS =
  "[&_input]:px-[calc(--spacing(3)-1px)]";

export const TABLE_VALUE_INSET_CLASS = "px-[calc(--spacing(2)-1px)]";

/** {@link TABLE_VALUE_INSET_CLASS} on the leading edge only — the table
 *  counterpart of {@link PROPERTY_VALUE_EDIT_LEAD_INSET_CLASS}: the phone
 *  editor's flag starts 8px in like the rest text, never flush to the ring. */
export const TABLE_VALUE_LEAD_INSET_CLASS = "pl-[calc(--spacing(2)-1px)]";
